import {
  getVisibilityOnPageSettings,
  VisibilityOnPagesWrapper
} from '@elfsight/widget-conditional-display';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { Portal, PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from './meta';
import { VerificationProvider } from './widget/providers';
import { Widget } from './widget/Widget';

const { name, alias } = meta;

export function AgeVerification() {
  const settings = useSettings();
  const { widgetId, editMode, customCSS, customJS, font, renderThumbnailMode } =
    settings;
  const visibilityOnPagesSettings = getVisibilityOnPageSettings(settings);

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    alias,
    widgetId
  );

  useDefineAPISchema();
  useFontsLoader([font]);
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <PortalNestProvider
      customCSSClassName={customCSSPrefixClassName}
      font={font}
    >
      <Portal>
        <VisibilityOnPagesWrapper
          editMode={editMode}
          widgetVisibilityOnPages={visibilityOnPagesSettings}
        >
          <StorageProvider name={name} widgetId={widgetId ?? ''}>
            <VerificationProvider>
              <Widget />
              <CustomCSS
                customCSS={customCSS}
                prefixClassName={customCSSPrefixClassName}
              />
            </VerificationProvider>
          </StorageProvider>
        </VisibilityOnPagesWrapper>
      </Portal>
    </PortalNestProvider>
  );
}
